export default function browser(_ref) {
    var DEFAULT_FEATURE_KEY = _ref.DEFAULT_FEATURE_KEY,
        getCookieFeatureNames = _ref.getCookieFeatureNames,
        getBrowserFeatureQueryKeys = _ref.getBrowserFeatureQueryKeys,
        getCookieValue = _ref.getCookieValue,
        hex2string = _ref.hex2string,
        stripLeadingText = _ref.stripLeadingText;

    function isFeatureEnabledInQueryString(featureName, queryString) {
        var featureKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_FEATURE_KEY;

        var browserFeatureQueryKeys = getBrowserFeatureQueryKeys(featureKey);

        return stripLeadingText(queryString, '?').split('&').map(function (query) {
            return query.split('=');
        }).filter(function (query) {
            return browserFeatureQueryKeys.includes(query[0]);
        }).find(function (featureQuery) {
            return featureQuery[1] === featureName;
        }) !== undefined;
    }

    function isFeatureEnabledInQueryParams(featureName) {
        var featureKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FEATURE_KEY;

        var queryString = decodeURI(window.location.search);
        return isFeatureEnabledInQueryString(featureName, queryString, featureKey);
    }

    function isFeatureEnabledInCookie(featureName) {
        var featureKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FEATURE_KEY;

        var cookieFeatureNames = getCookieFeatureNames(featureKey);

        var featureQueryString = cookieFeatureNames.map(function (cookieFeatureName) {
            return getCookieValue(cookieFeatureName);
        }).map(function (featureValue) {
            return hex2string(featureValue);
        }).filter(function (featureValue) {
            return featureValue !== '';
        }).join('&');

        return isFeatureEnabledInQueryString(featureName, featureQueryString, featureKey);
    }

    function getFeatureParamsFromCookie() {
        var featureKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FEATURE_KEY;

        var cookieFeatureNames = getCookieFeatureNames(featureKey);

        return cookieFeatureNames.map(function (cookieFeatureName) {
            return getCookieValue(cookieFeatureName);
        }).map(function (featureValue) {
            return hex2string(featureValue);
        }).filter(function (featureValue) {
            return featureValue !== '';
        }).join('&');
    }

    function isClientFeatureEnabled(featureName) {
        var featureKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FEATURE_KEY;

        return isFeatureEnabledInQueryParams(featureName, featureKey) || isFeatureEnabledInCookie(featureName, featureKey);
    }

    return {
        isFeatureEnabledInQueryString: isFeatureEnabledInQueryString,
        isFeatureEnabledInQueryParams: isFeatureEnabledInQueryParams,
        isFeatureEnabledInCookie: isFeatureEnabledInCookie,
        isClientFeatureEnabled: isClientFeatureEnabled,
        getFeatureParamsFromCookie: getFeatureParamsFromCookie
    };
}